import React, { useEffect, useState } from 'react';
import {
  Button,
} from 'reactstrap';
import { useDispatch, useSelector } from "react-redux";
import { translate } from "react-translate";
import { 
  actionDeleteKitFromOrder
} from 'store/actions/practiceOrdersActions';

//Sweet alert
import SweetAlert from "react-bootstrap-sweetalert";
import { actionSweetAlert } from "store/actions/commonActions";

const KitOverview = (props) => {
    const dispatch = useDispatch();
    const { t, reservedKit } = props;
    const { orderEdit, kitDeleteLoading } = useSelector(state => state.practiceOrdersReducer);

    const unlinkKit = (e, kit) => {
        e.preventDefault();
    
        dispatch(
            actionSweetAlert(
                <SweetAlert
                    warning
                    title={t("order-unlink-kit-title")}
                    onConfirm={() => {
                        dispatch(actionDeleteKitFromOrder(orderEdit._id, kit._id, kit.type));
                        dispatch(actionSweetAlert(null));
                    }}
                    onCancel={() => dispatch(actionSweetAlert(null))}
                    confirmBtnBsStyle="primary"
                    cancelBtnBsStyle="info"
                    confirmBtnText={t("order-unlink-kit-confirm-btn")}
                    cancelBtnText={t("order-unlink-kit-deny-btn")}
                    showCancel
            >
                </SweetAlert>
            )
        );
    }

    return (
        <div className={"assigned-kit-container"}>
            <div 
            key={`rk-${reservedKit._id}`} 
            className="assigned-kit"
            >
            {`Kit ${reservedKit.friendly_id} (assets: ${reservedKit.assets.length})`}
            </div>

            <Button 
            size="sm" 
            color="primary"
            onClick={e => unlinkKit(e,reservedKit)}
            disabled={kitDeleteLoading}
            > 
            {t("remove-kit")} 
            </Button>
        </div>
    );
};

export default translate("practice-orders")(KitOverview);
